
document.addEventListener("DOMContentLoaded", function () {
  let greetingMessageSection = document.getElementById("greetingMessageSection");
  let greetingSection = document.getElementById("greetingMessageContainer");
  let saveButton = document.getElementById("saveGreetingMessage");
  let messageInput = document.getElementById("greetingMessageInput");
  let confirmationText = document.getElementById("saveConfirmation");
  let variantField = document.getElementById("greetingMessageVariantId");

  // greeting message selector NEVER flashes on load
  greetingMessageSection.style.display = "none";

  function activateFirstCollection(sectionId) {
    let section = document.getElementById(sectionId);
    if (!section) return;

    let firstTab = section.querySelector(".collection-tab");
    let firstContent = section.querySelector(".collection-content");

    if (firstTab && firstContent) {
      section.querySelectorAll(".collection-tab").forEach(t => t.classList.remove("active"));
      section.querySelectorAll(".collection-content").forEach(c => c.classList.remove("active"));
      firstTab.classList.add("active");
      firstContent.classList.add("active");
    }
  }

  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("collection-tab")) {
      let collectionName = event.target.getAttribute("data-collection");
      let section = event.target.closest("#greetingMessageSection");
      if (!section) return;

      section.querySelectorAll(".collection-content").forEach(c => {
        c.classList.remove("active");
        c.style.display = "none";
      });

      section.querySelectorAll(".collection-tab").forEach(t => t.classList.remove("active"));
      event.target.classList.add("active");

      let selectedCollection = section.querySelector(`.collection-content[data-collection="\${collectionName}"]`);
      if (selectedCollection) {
        selectedCollection.classList.add("active");
        selectedCollection.style.display = "block";
        setTimeout(() => {}, 500);
      }
    }
  });

  document.addEventListener("progressBarUpdated", function () {
    let activeStep = document.querySelector(".progress-bar .step.active");
    if (activeStep && activeStep.textContent.trim() === "Greeting Message") {
      activateFirstCollection("greetingMessageSection");
      attachCollectionListeners();
      initGreetingCarousels();
    }
    setupGreetingAddToCart();
  });

  function attachCollectionListeners() {
    document.addEventListener("click", function (event) {
      if (event.target.classList.contains("collection-tab")) {
        let collectionName = event.target.getAttribute("data-collection");
        let section = event.target.closest("#greetingMessageSection");
        if (!section) return;

        section.querySelectorAll(".collection-content").forEach(c => {
          c.classList.remove("active");
          c.style.display = "none";
        });

        section.querySelectorAll(".collection-tab").forEach(t => t.classList.remove("active"));
        event.target.classList.add("active");

        let selectedCollection = section.querySelector(`.collection-content[data-collection="\${collectionName}"]`);
        if (selectedCollection) {
          selectedCollection.classList.add("active");
          selectedCollection.style.display = "block";
          setTimeout(() => {}, 500);
        }
      }
    });
  }

saveButton.addEventListener("click", async function () {
  const message = messageInput.value.trim();
  const variantId = parseInt(variantField?.value || "0");

  if (!message) {
    alert("Please enter a message before saving.");
    return;
  }

  if (!variantId) {
    alert("No matching variant ID found.");
    return;
  }

  try {
    const cart = await fetch("/cart.js").then(res => res.json());
    const targetItem = cart.items.find(
      item => item.variant_id === variantId
    );

    if (!targetItem) {
      alert("No matching greeting item found in cart.");
      return;
    }

    // Remove current item
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: targetItem.key,
        quantity: 0
      })
    });

    // Re-add with message
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: targetItem.variant_id,
            quantity: targetItem.quantity,
            properties: {
              ...targetItem.properties,
              Grussnachricht: message
            }
          }
        ]
      })
    });

    confirmationText.style.display = "block";
    setTimeout(() => (confirmationText.style.display = "none"), 3000);
    updateCartUI();

    // ✅ Update cart attribute
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          current_step: "1"
        }
      })
    });

    // ✅ Dispatch event to trigger progress bar UI update
    document.dispatchEvent(new CustomEvent("cartStepChangedExternally", {
      detail: { newStep: 1 }
    }));

  } catch (error) {
    console.error("Error updating greeting message:", error);
  }
});



  function updateCartUI() {
    fetch("/cart")
      .then(response => response.text())
      .then(html => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, "text/html");
        let newCartItems = doc.querySelector("#main-cart-items");

        if (newCartItems) {
          document.querySelector("#main-cart-items").innerHTML = newCartItems.innerHTML;
        }
      });
  }

  function setupGreetingAddToCart() {
    document.querySelectorAll(".add-to-cart.greeting-collection-item").forEach(button => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const variantId = this.getAttribute("data-variant-id");
        const greetingMessage = document.getElementById("greetingMessageInput")?.value || "";

        this.innerText = "...";
        this.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId),
                quantity: 1,
                properties: {
                  Grussnachricht: greetingMessage,
                }
              }
            ],
            sections: ["main-cart-items"],
            sections_url: window.location.pathname
          })
        })
          .then(response => response.json())
          .then(() => {
            document.getElementById("greetingMessageVariantId").value = variantId;
            return fetch(`/?sections=main-cart-items`);
          })
          .then(res => res.json())
          .then(sectionData => {
            const html = sectionData["main-cart-items"];
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCartItems = doc.querySelector("#main-cart-items");
            const currentCart = document.querySelector("#main-cart-items");

            if (newCartItems && currentCart) {
              currentCart.innerHTML = newCartItems.innerHTML;
            }

            document.getElementById("greetingMessageContainer").style.display = "block";

            const greetingCarousel = document.querySelector(".products-carousel.greeting-carousel");
            const greetingMessageContainer = document.getElementById("greetingMessageContainer");

            if (greetingCarousel && greetingMessageContainer) {
              greetingCarousel.style.paddingBottom = "0px";
              greetingMessageContainer.style.marginTop = "40px";
            }

            this.innerText = "Hinzugefügt!";
            setTimeout(() => {
              this.innerText = "In den Warenkorb";
              this.disabled = false;
            }, 1000);
          })
          .catch(error => {
            console.error("Error adding to cart:", error);
            this.innerText = "Error!";
            setTimeout(() => {
              this.innerText = "In den Warenkorb";
              this.disabled = false;
            }, 2000);
          });
      });
    });
  }

  function initGreetingCarousels() {
    document.querySelectorAll("#greetingMessageSection products-carousel").forEach(carousel => {
      if (!carousel.swiper && typeof carousel.connectedCallback === "function") {
        carousel.connectedCallback();
      }
    });
  }

  activateFirstCollection("greetingMessageSection");
  attachCollectionListeners();
  setupGreetingAddToCart();
});